import { Controller } from "@hotwired/stimulus"

// Marks which edges of a horizontal scroller have content scrolled out of
// view, so CSS (`.scroll-fade-x` in application.css) can fade that edge. The
// sensor tab strip hides its scrollbar, and on a phone the fade is the only
// cue that more tabs exist (CONEK-8191).
//
// Sets `data-fade-start` while it can scroll back and `data-fade-end` while it
// can scroll forward; neither when everything fits. Re-checked on scroll and
// whenever the scroller or its content changes size (rotation, fonts landing).
export default class extends Controller {
  connect() {
    this.update = this.update.bind(this)
    this.element.addEventListener("scroll", this.update, { passive: true })
    this.resizeObserver = new ResizeObserver(this.update)
    this.resizeObserver.observe(this.element)
    if (this.element.firstElementChild) {
      this.resizeObserver.observe(this.element.firstElementChild)
    }
    this.update()
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.update)
    this.resizeObserver?.disconnect()
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.element
    // 1 px of slack: zoomed and high-DPI layouts report fractional scroll
    // positions that never reach the exact end.
    this.element.toggleAttribute("data-fade-start", scrollLeft > 1)
    this.element.toggleAttribute(
      "data-fade-end",
      scrollLeft + clientWidth < scrollWidth - 1,
    )
  }
}
